import { useSelector } from "react-redux";

import { BATWORK_LINK } from "@config/links";

import { AVAILABLE_LANGS } from "@typings/globals";

import { getLanguage } from "@work/redux/localisation/localisation.selectors";

const RedirectToLandingPage = (): null => {
  const language: AVAILABLE_LANGS = useSelector(getLanguage);

  window.location.href = `${BATWORK_LINK.replace("{{lang}}", language)}`;

  return null;
};

export { RedirectToLandingPage };
